export const IMAGE_WIDTHS = [400, 800, 1200, 1800] as const
export const LQIP_WIDTH = 32
export const WEBP_QUALITY = 80
export const LARGEST_WIDTH = IMAGE_WIDTHS[IMAGE_WIDTHS.length - 1]
export const LARGEST_SUFFIX = `-${LARGEST_WIDTH}.webp`

export function pathWithWidth(stem: string, width: number): string {
  return `${stem}-${width}.webp`
}

export function stemFromLargest(largestPath: string): string {
  return largestPath.replace(new RegExp(`${LARGEST_SUFFIX}$`), '')
}

export function isOptimizedPath(path: string | undefined | null): boolean {
  return !!path && path.endsWith(LARGEST_SUFFIX)
}
